import React from 'react';
import { useTranslation } from 'react-i18next';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import type { CreateNewOptionProps } from '@lib/components/Select/Select';
import styles from '../SelectPanel.module.scss';

type SelectPanelCreateActionProps = {
  createNewOptionProps: CreateNewOptionProps;
};

export function SelectPanelCreateAction({
  createNewOptionProps,
}: SelectPanelCreateActionProps) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className={styles.createAction}
      onClick={() => {
        createNewOptionProps.onCLick();
      }}
    >
      <MaterialIcon icon="add" size="md-18" />
      <span>
        {createNewOptionProps.title ??
          t('create-new', { defaultValue: 'Create new' })}
      </span>
    </button>
  );
}
